import { Flex, Loader, Text } from "@mantine/core";
import useGetRespostasQuestionario from "../../hooks/useGetRespostasQuestionario";

type ColaboradoresRespondidosProperties = {
  empresaId: string;
  questionarioId: string;
};

/**
 * Componente que exibe a quantidade de colaboradores convidados da empresa atual em um questionário
 * @param root0 Properties
 * @param root0.questionarioId id do questionário
 * @param root0.empresaId id da empresa
 * @returns Componente
 */
function ColaboradoresRespondidos({ empresaId, questionarioId }: ColaboradoresRespondidosProperties) {
  const { data = [], isFetching } = useGetRespostasQuestionario(empresaId, questionarioId);

  if (isFetching) {
    return (
      <Flex mih={50} gap="xs" justify="center" align="flex-start" direction="column" wrap="wrap">
        <Loader size={36} />
      </Flex>
    );
  }

  return (
    <Flex mih={50} gap="xs" justify="center" align="flex-start" direction="column" wrap="wrap">
      <Text fw={300} fz="xs">
        Quantidade de respostas
      </Text>
      <Text fw={500} fz="md">
        {data.length}
      </Text>
    </Flex>
  );
}

export default ColaboradoresRespondidos;
